<template>
  <div class="row blaSummaryContainer">
    <div class="col-12 col-md-10 offset-md-1 mt-2">
      <div class="row">
        <div class="col-12 col-md-4 offset-md-4 mt-md-5">
          <div class="blaSummaryBox">
            <div class="blaSummaryBoxHeader text-center">
              <div class="blaSummaryTitle">Gratulálunk</div>
              <img
                :src="require('@/assets/img/grat.png')"
                alt="gratulations"
                class="img-fluid"
              />
              <div class="blaSummarySubTitle">Teljesítetted a leckét!</div>
            </div>
            <div class="blaSummaryBoxContent">
              <div v-show="!showLoader">
                <div class="row py-3 align-center">
                  <div class="col-6 text-right">
                    <img
                      :src="require('@/assets/img/score.png')"
                      alt="score"
                      class="blaSummaryScoreImage"
                    />
                  </div>
                  <div class="col-6 text-left blaSummaryScore">
                    +{{ userScores }}
                  </div>
                </div>
                <div class="row pb-2 align-content-center">
                  <div class="col-12 text-center">
                    <span class="blaSummaryScoreTitle"> Sikeres találat: </span>
                    <span class="blaSummaryScore ml-1">
                      {{ goodAnswers }} / {{ maxAnswers }}
                    </span>
                  </div>
                </div>
                <div class="row pb-2 align-center text-center">
                  <!-- <SummaryStars :percent="percent" /> -->
                </div>
                <div class="row pb-4 mt-4 align-content-center">
                  <div class="col-10 offset-1 col-md-6 offset-md-3 col-md-6">
                    <div
                      class="blaSummaryNextButton"
                      @click="$router.push({ name: 'home' })"
                    >
                      Vissza a leckékhez
                    </div>
                  </div>
                </div>
              </div>
              <div v-show="showLoader" class="text-center py-3">
                <!-- CSS based loader -->
                <div class="lds-ring">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  components: {},
  data: () => ({
    // lessonId: 0, //For dev
    lessonId: 0,
    currentPosition: 100,
    maxScores: 0,
    maxAnswers: 0,
    earnedScores: 0,
    goodAnswers: 0,
    percent: 0,
    userScores: 0,
    showLoader: false,
  }),
  methods: {
    async getSummaryData() {
      await axios
        .post(this.$store.getters.getApiUrl + "/api/summary", {
          token: this.$store.getters.getToken,
          lessonId: this.lessonId,
          earnedScores: this.earnedScores,
          goodAnswers: this.goodAnswers,
        })
        .then((response) => {
          this.maxScores = response.data.maxScores;
          this.maxAnswers = response.data.maxAnswers;
          this.percent = response.data.percent;
          this.userScores = response.data.userScores;
          this.showLoader = false;
        })
        .catch((error) => {
          // console.log("summary - error: ", error);
        });
    },
  },
  mounted: function () {
    this.lessonId = this.$route.params.lessonId;
    this.earnedScores = this.$store.getters.earnedScores;
    this.goodAnswers = this.$store.getters.goodAnswers;
    this.showLoader = true;
    this.getSummaryData();
  },
};
</script>
